<br />
<div class="text-center" *ngIf="loading">
  <app-calibrant-load [small]="true"></app-calibrant-load>
</div>
<div style="padding-bottom: 4%">
  <div class="float-left">
    <h5 class="title-header">Program Parameters</h5>
  </div>
</div>
<app-program-details *ngIf="program" [program]="program"></app-program-details>
<app-dispatch-listings [program]="program"></app-dispatch-listings>
